// extracted by mini-css-extract-plugin
export default {"container":"CategoriesSelect_container__59GBw","item":"CategoriesSelect_item__cyTTi","itemActive":"CategoriesSelect_itemActive__RL0Z0"};